"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwiftError = void 0;
class SwiftError extends Error {
    constructor(message, swiftErrStack) {
        super(message);
        this.stack = swiftErrStack;
    }
}
exports.SwiftError = SwiftError;
//# sourceMappingURL=errors.js.map